import Icon from "@Atom/Icon";
import Styles from "./styles.module.scss";
import Images from "@Theme/Images";
import { useCallback, useEffect, useMemo, useState } from "react";
import { getDetailHistoryProfile } from "@Services/home";
import moment from "moment";
import { Skeleton } from "@mui/material";

export default function DetailModal({
  handleClose = () => {},
  showDetail = null,
}) {
  const [onHover, setOnhover] = useState("");

  const [loading, setLoading] = useState(false);
  const [listHistory, setListHistory] = useState(null);

  const refetchData = useCallback(async () => {
    try {
      setLoading(true);
      const { response } = await getDetailHistoryProfile(showDetail?.id);
      setListHistory(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }, [showDetail]);

  useEffect(() => {
    if (showDetail) {
      refetchData();
    }
  }, [showDetail, refetchData]);

  const modifiedData = useMemo(() => {
    const copied = loading
      ? Array.from({ length: 5 }, (_, idx) => idx + 1)
      : [...(listHistory?.logs || [])];

    const interviewMap = [
      {
        remark: "Undangan Interview RO Dikirim",
        key: "interviewer",
        value: listHistory?.candidateLink?.interviewRO,
      },
      {
        remark: "Undangan Interview Client Dikirim",
        key: "interviewer",
        value: listHistory?.candidateLink?.interviewClient,
      },
    ];

    interviewMap.forEach(({ remark, key, value }) => {
      const latestItem = copied
        .filter((item) => item.remark === remark)
        .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0];

      if (latestItem && value) {
        latestItem[key] = value;
      }
    });

    return copied;
  }, [listHistory, loading]);

  return (
    <div className={Styles.container}>
      <div className={Styles.header}>
        <span>Status Lamaran</span>
        <div className={Styles.iconCross} onClick={handleClose}>
          <Icon icon={"cross"} size={24} color={"#0A0A0A"} />
        </div>
      </div>

      <div className={Styles.content}>
        <div className={Styles.descBox}>
          <div className={Styles.top}>
            <div className={Styles.imagesProfile}>
              <img
                src={showDetail?.img ? showDetail?.img : Images.PERMATA_LOGO}
                alt=""
              />
            </div>
            <div className={Styles.profile}>
              <span>{showDetail?.name || "-"}</span>
              <span>{showDetail?.experience || "-"}</span>
            </div>
          </div>

          <div className={Styles.middle}>
            {showDetail?.workType && (
              <div className={Styles.card}>{showDetail?.workType}</div>
            )}

            {showDetail?.contractType && (
              <div className={Styles.card}>{showDetail?.contractType}</div>
            )}

            {showDetail?.workMethod && (
              <div className={Styles.card}>{showDetail?.workMethod}</div>
            )}
          </div>

          <div className={Styles.bottom}>
            <div
              // onMouseEnter={() => setOnhover(true)}
              // onMouseLeave={() => setOnhover(false)}
              onClick={(e) => {
                if (showDetail?.websiteCompany) {
                  e.stopPropagation();
                  window.open(showDetail?.websiteCompany);
                }
              }}
            >
              <div className={Styles.icon}>
                <Icon icon={"building"} size={20} color={"#242424"} />
              </div>
              <span className={`${onHover && Styles.onHover}`}>
                {showDetail?.client || "-"}
              </span>
              {onHover && (
                <div className={Styles.iconHover}>
                  <Icon icon={"arrow-up-right"} size={14} color={"#1571DE"} />
                </div>
              )}
            </div>
            <div>
              <div className={Styles.icon}>
                <Icon icon={"map-pin-solid"} size={20} color={"#242424"} />
              </div>
              <span>{showDetail?.location || "-"}</span>
            </div>
          </div>
        </div>

        <div className={Styles.historyBox}>
          {modifiedData?.length > 0 ? (
            modifiedData?.map((el, idx) => {
              return (
                <div className={Styles.historyList} key={idx}>
                  <div className={Styles.bulletBox}>
                    <div className={Styles.bullet}>
                      <div className={Styles.bulletBlue}></div>
                    </div>

                    <div className={Styles.line}></div>
                  </div>
                  <div className={Styles.historyContent}>
                    <div className={Styles.date}>
                      <span>
                        {loading ? (
                          <Skeleton height={20} />
                        ) : el?.createdAt ? (
                          moment(new Date(el?.createdAt))?.format(
                            "D MMMM YYYY, HH:mm"
                          )
                        ) : (
                          "-"
                        )}
                      </span>
                    </div>
                    <div className={Styles.status}>
                      <span>
                        {loading ? <Skeleton height={20} /> : el?.remark || "-"}
                      </span>
                    </div>

                    {el?.interviewer && (
                      <div className={Styles.otherInformation}>
                        <div>
                          <div className={Styles.left}>
                            <div>
                              <Icon
                                icon={"person_outline"}
                                size={16}
                                color={"#757575"}
                              />
                            </div>
                            <span>Interviewer</span>
                          </div>

                          <span className={Styles.right}>
                            {el?.interviewer?.interviewerName || "-"}
                          </span>
                        </div>
                        <div>
                          <div className={Styles.left}>
                            <div>
                              <Icon
                                icon={"calendar"}
                                size={16}
                                color={"#757575"}
                              />
                            </div>
                            <span>Tanggal</span>
                          </div>

                          <span className={Styles.right}>
                            {el?.interviewer?.date
                              ? moment(new Date(el?.interviewer?.date))?.format(
                                  "D MMMM YYYY"
                                )
                              : "-"}
                          </span>
                        </div>
                        <div>
                          <div className={Styles.left}>
                            <div>
                              <Icon
                                icon={"clock"}
                                size={16}
                                color={"#757575"}
                              />
                            </div>
                            <span>Jam</span>
                          </div>

                          <span className={Styles.right}>
                            {el?.interviewer?.time || "-"}
                          </span>
                        </div>

                        <div>
                          <div className={Styles.left}>
                            <div>
                              <Icon
                                icon={"map-pin-solid"}
                                size={16}
                                color={"#757575"}
                              />
                            </div>
                            <span>Lokasi</span>
                          </div>

                          <span className={Styles.right}>
                            <span>
                              {el?.interviewer?.method
                                ? el?.interviewer?.method === "Offline"
                                  ? el?.interviewer?.via
                                    ? el?.interviewer?.via?.includes("::")
                                      ? el?.interviewer?.via?.split("::")[0]
                                      : el?.interviewer?.via
                                    : "-"
                                  : el?.interviewer?.method
                                : "-"}
                            </span>
                            {el?.interviewer?.method
                              ? el?.interviewer?.method === "Offline"
                                ? el?.interviewer?.via
                                  ? el?.interviewer?.via?.includes("::")
                                    ? el?.interviewer?.via?.split("::")[1]
                                    : ""
                                  : ""
                                : el?.interviewer?.via
                              : "-"}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              );
            })
          ) : (
            <div className={Styles.emptyHandler}>
              <span>Tidak Ada Log Yang ditemukan</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
